import React from "react";
import "./Aero_Sleep_Technology.css";
import Common_Back_Header from "../../../common_components/common_back_btn/Common_Back_Btn";
import Common_Title from "../../../common_components/common_title/Common_Title";

const Aero_Sleep_Technology = () => {
  return (
    <section className="Peace_Of_Mind City_Guard Aero_Sleep_Technology">
      <div className="container">
        <Common_Back_Header backNavigation={-1} />

        <Common_Title
          title={"AERO SLEEP TECHNOLOGY"}
          subtitle={
            "Better sleep means feeling happier, healthier and better rested. By improving Mental &Physical Health, a good night’s sleep plays an inevitable role in leading a healthy lifestyle. Improper rest, commonly known as a sleep disorder tends to have a negative effect on stress resistance, eating habits & physical condition of the body. Excessive daytime fatigue, poor memory, irritability, weight problems and lack of energy may also be symptoms of chronic insomnia or a real medical sleep disorder which needs the immediate attention of a doctor."
          }
        />

        <div className="main_content_div">
          <div className="banner_img_div">
            <img
              src="/assets/images/hospitality/aero_sleep/banner.png"
              className="banner_img"
            />
          </div>

          <div className="text_below_img">
            <Common_Title
              subtitle={
                "Experience a revolution in restorative rest with the Majesty Mattress, powered by cutting-edge Aero Sleep technology. Designed for those who refuse to compromise on comfort, Majesty transforms your bedroom into a temperature-regulated sanctuary."
              }
            />
          </div>

          <div className="common_gray_div">
            <p className="common_section_title">
              The Science of "Total Breathability"
            </p>
            <p className="normal_text">
              At the heart of the Majesty experience is an exclusive,
              sustainable, open-cell system. This isn't just a mattress; it's a
              high-performance ventilation engine for your body.
            </p>

            <p className="p_title remove_space">Advanced Thermal Control:</p>
            <p className="p_text bottom_space">
              Our innovative materials move heat away from your skin 34% faster
              than standard mattresses, ensuring you stay cool all night long.
            </p>

            <p className="p_title remove_space">Safety Through Airflow:</p>
            <p className="p_text bottom_space">
              Aero Sleep technology is engineered to minimize resistance. By
              maintaining high oxygen flow and exceptionally low asphyxiation
              levels in all conditions, we provide a sleeping environment that
              is as safe as it is plush.
            </p>

            <p className="p_title remove_space"> The "6-Hour" Efficiency:</p>
            <p className="p_text bottom_space">
              Backed by rigorous scientific research, Majesty optimizes every
              minute of your rest. By providing perfect spinal alignment &
              superior hygiene, we turn 6 hours of sleep into a full cycle of
              total physical and mental recovery.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Aero_Sleep_Technology;
